// Import all actions
import * as actions from '../../actions/user/userActions'

export const initialState = {
  users: [],
  loading: false,
  hasErrors: false,
  login: false
}

export default function usersReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_USERS:
      return { ...state, loading: true }
    case actions.GET_USERS_SUCCESS:
      return { users: [...state.users, action.payload], loading: false, hasErrors: false, login: action.payload.login }
    case actions.GET_USERS_FAILURE:
      return { ...state, loading: false, hasErrors: true }
    case actions.USER_LOGIN_SUCCESS:
      return { ...state, login: true, hasErrors: false, loading: false }
    case actions.USER_LOGOUT_SUCCESS:
      return { ...state, login: false, hasErrors: false }
    default:
      return state
  }
}